import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import { LimitReached } from '~/pages/errors/LimitReached';
import { NotFound } from '~/pages/errors/NotFound';
import { PQrCodeDeactivated } from '~/pages/errors/PQrCodeDeactivated';

const ERROR_ROUTES: RouteObject[] = [
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: PATH.QR.LIMIT_REACHED,
    element: <LimitReached />,
  },
  {
    path: PATH.QR.DEACTIVATED,
    element: <PQrCodeDeactivated />,
  },
];

export { ERROR_ROUTES };
